module.exports = [
 {
  "start": 83,
  "end": 10291,
  "text": "Im Not The Girl Who Misses Much",
  image: require('./PICKELPORNO_holder.jpg'),
   },

]


// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/room3/audio5/03_5MCA Im Not The Girl Who Misses Much.js